import * as _ from 'underscore';
import { Filter } from '../helpers/Filter';
import { ServerFilterClauses } from '../helpers/ServerFilterClauses';
import { ContentFilterKeyName, IContentFilters } from '../models/ContentFilters';
import { Module } from '../Module';
import { ICompositeFilterClause, IFilterClause } from '../ServerApi/types/IFilterClause';

export class ContentFilterService {

  public static $inject = ['$location'];

  private $location: ng.ILocationService;

  constructor($location: ng.ILocationService) {
    this.$location = $location;
  }

  public getFilter(explicitFilterKeys?: ContentFilterKeyName[], implicitFilters?: Partial<IContentFilters<string>>): ICompositeFilterClause {
    return Filter.and(this.getFilterClauses(explicitFilterKeys, implicitFilters));
  }

  public getFilterClauses(explicitFilterKeys?: ContentFilterKeyName[], implicitFilters?: Partial<IContentFilters<string>>): IFilterClause[] {
    const explicitFilters: Partial<IContentFilters<string>> = _(this.$location.search()).pick(explicitFilterKeys);
    const filterValues = _.extend(explicitFilters, implicitFilters);

    return ServerFilterClauses.create(filterValues);
  }

}

Module.instance().service('ContentFilterService', ContentFilterService);
